import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { useAppStore } from '../store/appStore';
import { ProfileImageUpload } from './ProfileImageUpload';

export const ProfileCard: React.FC = () => {
  const { currentAccount, updateAccount } = useAppStore();
  const [isEditing, setIsEditing] = useState(false);
  const [tempName, setTempName] = useState(currentAccount?.displayName || '');
  const [tempInstagram, setTempInstagram] = useState(currentAccount?.instagramUrl || '');
  const [showSuccess, setShowSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!currentAccount) return null;

  const handleEditClick = () => {
    setIsEditing(true);
    setTempName(currentAccount.displayName);
    setTempInstagram(currentAccount.instagramUrl);
    setShowSuccess(false);
    setError(null);
  };

  const handleSaveClick = async () => {
    try {
      await updateAccount(currentAccount.id, {
        displayName: tempName,
        instagramUrl: tempInstagram,
        handle: tempInstagram.replace('@', '').toLowerCase(),
      });
      setIsEditing(false);
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 3000);
    } catch {
      setError('Kunne ikke lagre endringer');
    }
  };

  const handleCancelClick = () => {
    setIsEditing(false);
    setTempName(currentAccount.displayName);
    setTempInstagram(currentAccount.instagramUrl);
    setShowSuccess(false);
    setError(null);
  };

  return (
    <Card className="bg-[#1a1a1a] border-none">
      <CardContent className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold text-white">Profil</h2>
          <div className="flex gap-2">
            {isEditing ? (
              <>
                <Button onClick={handleCancelClick} className="bg-white/10 hover:bg-white/20 text-white text-sm">
                  Avbryt
                </Button>
                <Button onClick={handleSaveClick} className="bg-white hover:bg-gray-200 text-black text-sm">
                  Lagre
                </Button>
              </>
            ) : (
              <Button onClick={handleEditClick} className="bg-white/10 hover:bg-white/20 text-white text-sm">
                Rediger
              </Button>
            )}
          </div>
        </div>
        {showSuccess && (
          <div className="bg-green-500/10 border border-green-500/20 text-green-400 px-4 py-2 rounded-lg mb-4 text-center text-sm">
            Endringer lagret!
          </div>
        )}
        {error && (
          <div className="bg-red-500/10 border border-red-500/20 text-red-400 px-4 py-2 rounded-lg mb-4 text-center text-sm">
            {error}
          </div>
        )}
        <div className="flex flex-col items-center mb-6">
          <ProfileImageUpload
            currentImageUrl={currentAccount.profileImageUrl}
            accountId={currentAccount.id}
          />
        </div>
        <div className="space-y-4">
          <input
            type="text"
            value={isEditing ? tempName : currentAccount.displayName}
            onChange={(e) => setTempName(e.target.value)}
            placeholder="Gruppenavn"
            disabled={!isEditing}
            className={`w-full p-3 rounded-lg bg-[#2a2a2a] text-white border-none focus:ring-2 focus:ring-white/50 outline-none ${
              !isEditing && 'opacity-75 cursor-not-allowed'
            }`}
          />
          <input
            type="text"
            value={isEditing ? tempInstagram : currentAccount.instagramUrl}
            onChange={(e) => setTempInstagram(e.target.value)}
            placeholder="Instagram-brukernavn"
            disabled={!isEditing}
            className={`w-full p-3 rounded-lg bg-[#2a2a2a] text-white border-none focus:ring-2 focus:ring-white/50 outline-none ${
              !isEditing && 'opacity-75 cursor-not-allowed'
            }`}
          />
        </div>
      </CardContent>
    </Card>
  );
};
